import type { QueryClient } from '@tanstack/react-query';
import { createContext, type RouterContextProvider } from 'react-router';

/**
 * Gives `loader`/`clientLoader` a query client without importing a singleton, so prerendering
 * and the browser can each use their own configuration. Populated by the root route middleware.
 */
export const queryClientContext = createContext<QueryClient>();

/** What a `loader`/`clientLoader` receives, it can read the context but not write to it. */
export type LoaderContext = Readonly<RouterContextProvider>;

export const getQueryClient = (context: LoaderContext) => context.get(queryClientContext);
